<template>
  <div>
    <article
      class="geodir-category-listing fl-wrap h-100 pointer"
      @click.stop="Terkepre(bejegyzes)"
    >
      <div class="geodir-category-img">
        <b-img-lazy
          :src="bejegyzes.Image"
          :key="bejegyzes.Image"
          :blank-src="require('../../assets/images/placeholder-image.jpg')"
          class="adat_jarmukep"
          fluid
          height="245px"
        ></b-img-lazy>
        <!-- <img class="adat_jarmukep" alt="" :src="bejegyzes.Image" /> -->
        <!-- <div class="overlay"></div> -->
        <div class="list-post-counter transparent">
          <bejegyzes-ikonok
            :bejegyzesIcons="[bejegyzes.Size]"
            :iconText="false"
            class="ikonok"
          ></bejegyzes-ikonok>
        </div>
        <a
          class="listing-geodir-category"
          :class="{ 'bg-green': isCleaned }"
          href="javascript:;"
        >
          <span class="adat_intezet">
            {{ $t(bejegyzes.Status) }}
          </span>
        </a>
      </div>
      <div class="geodir-category-content fl-wrap h-100">
        <h3>
          <a href="javascript:;"
            ><span class="adat_jarmunev">{{ $t('ui_garbagePile') }}</span></a
          >
        </h3>
        <div class="geodir-category-options fl-wrap">
          <div class="geodir-category-location">
            <a
              class="map-item scroll-top-map pointer mr-4"
              :class="{ disabled: !bejegyzes.Latitude }"
            >
              <k-icon name="fa-map-marker-alt" class="pr-1"></k-icon>

              <span class="adat_hely">
                {{ bejegyzes.Locality || 'Megnézem térképen' }}
              </span>
            </a>
            <a class="map-item scroll-top-map disabled mr-4">
              <k-icon name="fa-calendar-alt" class="pr-1"></k-icon>

              <span class="adat_hely">
                {{ bejegyzes.Created | toShortDate }}
              </span>
            </a>
            <a class="map-item scroll-top-map disabled" v-if="isCleaned">
              <k-icon name="fa-check" class="pr-1"></k-icon>

              <span class="adat_hely"> {{ $t(bejegyzes.Status) }} </span>
            </a>
          </div>
        </div>
        <p v-if="bejegyzes.Note">
          {{ bejegyzes.Note }}
        </p>
        <bejegyzes-ikonok
          :bejegyzesIcons="bejegyzes.Types"
          :iconText="true"
          class="ikonok d-inline-flex flex-wrap w-100 pt-4"
        ></bejegyzes-ikonok>
      </div>
    </article>
  </div>
</template>

<script>
import $ from 'jquery';

import { mapGetters } from 'vuex';
import { eventBus } from '../../main';
import { Statuszok } from '../../data/enums/kodszotar/statuszok';
export default {
  name: 'bejegyzes-info',
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {
    Terkepre(bejegyzes) {
      if (bejegyzes.Latitude && bejegyzes.Longitude) {
        this.$emit('Terkepre', {
          latitude: bejegyzes.Latitude,
          longitude: bejegyzes.Longitude,
          id: bejegyzes.Id,
        });
      }
    },

    HivoszamKitoltes(data) {
      eventBus.$emit('Modal:k-hivonev-kitoltes', {
        state: true,
        data: data,
      });
    },
  },
  computed: {
    ...mapGetters({}),
    isCleaned() {
      return this.bejegyzes.Status == Statuszok.Cleaned;
    },
  },
  watch: {},
  props: {
    bejegyzes: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style scoped>
img {
  max-height: 245px !important;
}

.card-listing .listing-item:not(.list-layout) .geodir-category-img {
  position: relative;
  height: 245px;
}
.card-listing .listing-item:not(.list-layout) .listing-geodir-category {
  position: absolute;
  bottom: -20px !important;
  top: inherit !important;
  left: 20px;
  padding: 10px 25px;
  color: #fff;
  border-radius: 4px;
  z-index: 5;
  box-shadow: 0px 0px 0px 7px rgba(255, 255, 255, 0.7);
}

.card-listing .geodir-category-content p {
  font-size: 13px;
}

.card-listing .geodir-category-location {
  border-top: 1px solid rgba(0, 0, 0, 0.25);
}
.card-listing .listing-item:not(.list-layout) .geodir-category-location {
  border-top: inherit;
  margin-top: inherit;
}
.card-listing .listing-item:not(.list-layout) .ikonok {
  border-top: 1px solid rgba(0, 0, 0, 0.25);
}

@media (max-width: 576px) {
  .center-col-list-wrap .listing-item.list-layout .geodir-category-img {
    height: 100% !important;
  }
  .listing-item.list-layout .listing-geodir-category {
    top: 100px;
    left: 5px;
    right: 5px;
    padding: 5px;
    bottom: inherit !important;
  }
}
</style>
